<template>
    <div class="feedback-star">
        <StarRating :rating="5-stars" class="feedback-star__rating" />
        <div class="feedback-star__line skeleton" v-if="skeleton" />
        <div class="feedback-star__line" v-else>
            <div class="feedback-star__progress" :style="{width: progress + '%'}"></div>
        </div>
    </div>
</template>

<script>
    import StarRating from '@/components/ui/StarRating';

    export default {
        components: {
            StarRating
        },
        props: {
            skeleton: {
                type: Boolean,
                default: false
            },
            stars: {
                type: Number,
                default: 0
            },
            progress: {
                type: Number,
                default: 0
            }
        }
    }
</script>

<style lang="scss">
    .feedback-star {
        margin-top: 10px;
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;

        &__line {
            background-color: #F5F6F8;
            height: 3px;
            position: relative;
            width: 100%;
        }

        &__rating {
            font-size: 8px !important;
            margin-right: 13px;
        }

        &__progress {
            background-color: $color-secondary;
            height: 3px;
            position: absolute;
            z-index: 2;
        }
    }
</style>